import React, { useState } from "react";
import { useIntl } from "react-intl";
import { StyledButton } from "../../Common/Components";
import { useUpdateStage } from "../../entities/api";
import AddAndEditStageModal from "./AddAndEditStageModal";

const EditStage = ({ stageCode }) => {
  const [openModal, setOpenModal] = useState(false);
  const { formatMessage } = useIntl();
  const { mutateAsync: updateFn, isPending: isUpdatePenfing } = useUpdateStage();

  const handleCloseModal = () => {
    setOpenModal((prev) => !prev);
  };

  const handleSendRequest = async (form) => {
    try {
      const { stageCode, ...data } = await form.validateFields();
      Object.keys(data)?.forEach((key) => {
        if (!data[key]) data[key] = null;
      });

      await updateFn({
        data,
        stageCode,
      });
      handleCloseModal();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <>
      <StyledButton type="text" size="small" onClick={handleCloseModal}>
        {formatMessage({ id: "manage", defaultMessage: "Manage" })}
      </StyledButton>
      {openModal && (
        <AddAndEditStageModal
          stageCode={stageCode}
          openModal={openModal}
          handleCloseModal={handleCloseModal}
          handleSendRequest={handleSendRequest}
          okButtonLoading={isUpdatePenfing}
        />
      )}
    </>
  );
};

export default EditStage;
